/*
  APBD / Holiday 2026 gift with purchase, sitewide.
  1. Free ornament: added automatically to any cart holding a qualifying item, held at qty 1, removed when the cart has nothing else.
  2. Free Heritage Tee: once qualifying items reach the threshold after discounts, the shopper picks a size and it is added at qty 1.
     They can remove it (we remember that and stop offering), and it comes out automatically if the cart drops below the threshold.
  Pricing is done by the automatic BXGY discounts in Shopify; this script only manages what is in the cart.
  GWP lines carry a hidden _gwp line property. Preview any date with ?hs_date=2026-11-27
*/
(function () {
  var C = window.HS_GWP;
  if (!C || C.off || window.HSGWP) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DECLINED = 'hs_gwp_tee_declined';
  var HAD = 'hs_gwp_tee_had';

  function now() {
    try {
      var q = new URLSearchParams(location.search).get('hs_date');
      if (q) { var d = new Date(q.length <= 10 ? q + 'T12:00:00-05:00' : q); if (!isNaN(d)) return d; }
    } catch (e) {}
    return new Date();
  }
  var t = now();
  if (t < new Date(C.start) || t > new Date(C.end)) return;

  function store(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  var nativeFetch = window.fetch.bind(window);
  function post(path, body) {
    return nativeFetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function notify(open) {
    [
      function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); },
      function () { document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); },
      function () { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); },
      function () { if (open && typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); },
      function () { if (window.HS && HS.cart) HS.cart(); }
    ].forEach(function (f) { try { f(); } catch (e) {} });
  }

  function gwp(i) { return i.properties && i.properties._gwp; }
  function qualifies(i) {
    return !gwp(i) && !i.gift_card && i.product_id !== C.teeProduct && i.product_id !== C.ornProduct;
  }

  var busy = false, again = false, last = null;

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    var changed = false;
    getCart().then(function (cart) {
      last = cart;
      var items = cart.items || [];
      var paid = items.filter(qualifies);
      var eligible = paid.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var orn = items.filter(function (i) { return gwp(i) === 'ornament'; });
      var tee = items.filter(function (i) { return gwp(i) === 'tee'; });
      var ops = [];

      // The ornament is gift only this season: drop any copy that was not added as the gift
      items.forEach(function (i) {
        if (i.product_id === C.ornProduct && gwp(i) !== 'ornament') ops.push(function () { return post('cart/change.js', { id: i.key, quantity: 0 }); });
      });
      // Ornament: exactly one whenever anything qualifying is in the cart
      if (paid.length) {
        if (!orn.length && C.ornAvailable) {
          ops.push(function () { return post('cart/add.js', { items: [{ id: C.ornVariant, quantity: 1, properties: { _gwp: 'ornament' } }] }); });
        }
        orn.forEach(function (l, n) {
          var want = n === 0 ? 1 : 0;
          if (l.quantity !== want) ops.push(function () { return post('cart/change.js', { id: l.key, quantity: want }); });
        });
      } else {
        orn.forEach(function (l) { ops.push(function () { return post('cart/change.js', { id: l.key, quantity: 0 }); }); });
      }

      // Tee: max one, only while qualifying spend is at or over the threshold
      if (tee.length) {
        tee.forEach(function (l, n) {
          var want = eligible >= C.threshold && n === 0 ? 1 : 0;
          if (l.quantity !== want) ops.push(function () { return post('cart/change.js', { id: l.key, quantity: want }); });
        });
        store(HAD, eligible >= C.threshold ? '1' : null);
      } else if (store(HAD) === '1') {
        // It was there and now it is gone while still eligible: the shopper removed it
        if (eligible >= C.threshold) store(DECLINED, '1');
        store(HAD, null);
      }
      if (!items.length || eligible < C.threshold) store(DECLINED, null);

      var offer = !tee.length && eligible >= C.threshold && store(DECLINED) !== '1' && C.sizes.some(function (s) { return s.available; });
      offer ? showPrompt() : hidePrompt();
      renderInline(!tee.length && eligible >= C.threshold && C.sizes.some(function (s) { return s.available; }));
      decorate(items);

      changed = ops.length > 0;
      return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve());
    }).catch(function () {}).then(function () {
      busy = false;
      // The cart page is server rendered, so show gift changes by reloading it
      if (changed && onCartPage()) { location.reload(); return; }
      if (changed) notify(false);
      if (again || changed) { again = false; setTimeout(reconcile, changed ? 150 : 0); }
    });
  }

  // Size picker
  var el;
  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'hs-gwp';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Choose your free Heritage Tee size');
    el.innerHTML =
      '<button type="button" class="hs-gwp__x" aria-label="No thanks">&times;</button>' +
      (C.teeImage ? '<img class="hs-gwp__img" src="' + C.teeImage + '" alt="">' : '') +
      '<div class="hs-gwp__body"><p class="hs-gwp__h">You unlocked a free Heritage Tee</p>' +
      '<p class="hs-gwp__s">Pick your size and it goes in the box.</p><div class="hs-gwp__sizes">' +
      C.sizes.map(function (s) {
        return '<button type="button" data-id="' + s.id + '"' + (s.available ? '' : ' disabled') + '>' + s.title + '</button>';
      }).join('') +
      '</div><button type="button" class="hs-gwp__no">No thanks</button></div>';
    document.body.appendChild(el);
    el.querySelector('.hs-gwp__x').onclick = el.querySelector('.hs-gwp__no').onclick = function () {
      store(DECLINED, '1'); hidePrompt();
    };
    el.querySelectorAll('[data-id]').forEach(function (b) {
      b.onclick = function () { addTee(b.getAttribute('data-id'), el, true); };
    });
    return el;
  }
  function sizeButtons() {
    return C.sizes.map(function (s) {
      return '<button type="button" data-id="' + s.id + '"' + (s.available ? '' : ' disabled') + '>' + s.title + '</button>';
    }).join('');
  }
  function addTee(id, box, openDrawer) {
    box.classList.add('is-busy');
    post('cart/add.js', { items: [{ id: Number(id), quantity: 1, properties: { _gwp: 'tee' } }] })
      .then(function () {
        store(HAD, '1'); store(DECLINED, null); hidePrompt();
        if (location.pathname.replace(/\/$/, '').slice(-5) === '/cart') { location.reload(); return; }
        notify(openDrawer); setTimeout(reconcile, 150);
      })
      .catch(function () {})
      .then(function () { box.classList.remove('is-busy'); });
  }

  // Cart page: the free tee shows as a row inside the cart, styled like the items around it, until a size is picked
  var inline;
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function renderInline(show) {
    if (!onCartPage()) return;
    var body = document.querySelector('cart-items tbody, #main-cart-items tbody, .cart-items tbody');
    var sample = body && body.querySelector('tr.cart-item:not(.hs-gwp-row)');
    if (!show || !sample) { if (inline) inline.remove(); inline = null; return; }
    if (inline && body.contains(inline)) return;
    if (inline) inline.remove();
    var money = function (c) { return window.HS && HS.money ? HS.money(c) : '$' + (c / 100).toFixed(2); };
    inline = document.createElement('tr');
    inline.className = 'cart-item hs-gwp-row';
    Array.prototype.forEach.call(sample.children, function (cell) {
      var td = document.createElement('td');
      td.className = cell.className;
      var c = cell.className;
      if (/media/.test(c)) {
        td.innerHTML = C.teeImage ? '<img class="cart-item__image hs-gwp-row__img" src="' + C.teeImage + '" alt="Heritage Tee" width="150" height="150" loading="lazy">' : '';
      } else if (/details/.test(c)) {
        td.innerHTML = '<p class="cart-item__name h4 break hs-gwp-row__name">Heritage Tee</p>' +
          '<div class="product-option"><s>' + money(C.teePrice) + '</s> <span>' + money(0) + '</span></div>' +
          '<p class="hs-gwp-row__tag">Free gift unlocked. Choose your size to add it.</p>' +
          '<div class="hs-gwp-row__sizes">' + sizeButtons() + '</div>';
      } else if (/quantity/.test(c)) {
        td.innerHTML = '<span class="hs-gwp-row__qty">Free with your order</span>';
      } else if (/totals/.test(c)) {
        td.innerHTML = '<div class="cart-item__price-wrapper"><span class="price price--end">' + money(0) + '</span></div>';
      }
      inline.appendChild(td);
    });
    body.insertBefore(inline, body.firstChild);
    inline.querySelectorAll('[data-id]').forEach(function (b) {
      b.onclick = function () { addTee(b.getAttribute('data-id'), inline, false); };
    });
  }
  // Cart page: gift lines lose their quantity stepper (the ornament also loses its remove button),
  // and the gift discount tags only show on the gift lines themselves
  var GIFT_TAG = /free heritage tee|free holiday ornament/i;
  function decorate(items) {
    if (!onCartPage() || !items) return;
    items.forEach(function (it, i) {
      var row = document.getElementById('CartItem-' + (i + 1));
      if (!row) return;
      var link = row.querySelector('a[href*="variant="]');
      if (link && link.getAttribute('href').indexOf('variant=' + it.variant_id) === -1) return;
      var g = gwp(it);
      row.classList.toggle('hs-gwp-line', !!g);
      row.classList.toggle('hs-gwp-line--orn', g === 'ornament');
      if (g) {
        row.querySelectorAll('.cart-item__quantity').forEach(function (td) {
          if (td.querySelector('.hs-gwp-row__qty')) return;
          var tag = document.createElement('span');
          tag.className = 'hs-gwp-row__qty';
          tag.textContent = 'Free gift';
          var wrap = td.querySelector('.cart-item__quantity-wrapper') || td;
          wrap.insertBefore(tag, wrap.firstChild);
        });
      } else {
        row.querySelectorAll('.discounts__discount').forEach(function (li) { if (GIFT_TAG.test(li.textContent)) li.remove(); });
      }
    });
  }

  // The theme re-renders the cart rows after every change, so put the row back when that happens
  if (onCartPage() && 'MutationObserver' in window) {
    var mo, wanted = false;
    var _render = renderInline;
    renderInline = function (show) { wanted = show; _render(show); };
    document.addEventListener('DOMContentLoaded', function () {
      var root = document.querySelector('cart-items') || document.body;
      var dt; mo = new MutationObserver(function () { clearTimeout(dt); dt = setTimeout(function () { getCart().then(function (c) { last = c; decorate(c.items); }).catch(function () {}); }, 200); if (wanted && (!inline || !document.body.contains(inline))) { inline = null; _render(true); } });
      mo.observe(root, { childList: true, subtree: true });
    });
  }

  function showPrompt() { if (/\/cart\/?$/.test(location.pathname)) return; build().classList.add('is-on'); }
  function hidePrompt() { if (el) el.classList.remove('is-on'); }

  // Watch every cart write, from the theme, Upcart or anything else
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(function () { setTimeout(reconcile, 60); }, function () {});
    return p;
  };
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url))) this.addEventListener('load', function () { setTimeout(reconcile, 60); });
    return open.apply(this, arguments);
  };

  window.HSGWP = {
    reconcile: reconcile,
    prompt: function () { store(DECLINED, null); reconcile(); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else reconcile();
  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcile(); });
})();
